import { useContext, useState } from 'react';
import { ActionModal } from '../../../../../../components/Modal';
import React from 'react';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../types/translation/Translator';
import { CompanyContext } from '../../../../../../../context/CompanyContext';
import { Button, CancelButton } from '../../../../../../components/Button';
import { useToast } from '../../../../../../../providers/ToastProvider';
import BinConstraintInfoPane from '../Panes/BinConstraintInfoPane';
import { BinConstraintInput } from '../../../../../../../types/bin_constraints/binConstraint.input';
import { useRequest } from '../../../../../../../requests/common/requestHook';
import { BinConstraintRequest } from '../../../../../../../requests/binConstraint.request';
import { BinConstraintContext } from '../../../../../../../context/BinConstraintContext';
import { BinConstraint } from '../../../../../../../types/bin_constraints/binConstraint';

interface CreateBinConstraintModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  pmdId?: string;
}

export default function CreateBinConstraintModal({ open, setOpen, pmdId }: CreateBinConstraintModalProps) {
  const { showToast } = useToast();
  const { binConstraints, setBinConstraints } = useContext(BinConstraintContext);

  const { currentCompany } = useContext(CompanyContext);

  const [input, setInput] = useState<BinConstraintInput>(
    new BinConstraintInput({ companyId: currentCompany.id, pmdId: pmdId, stockLocationId: '' }),
  );

  const [create, { loading }] = useRequest(BinConstraintRequest.create);

  const handleCreate = async () => {
    const result = await create({ data: [input.forCreate()] });
    if (!result) return;

    const constraint = result[0];
    binConstraints.set(constraint.id, new BinConstraint(constraint));
    setBinConstraints(new Map(binConstraints));
    setOpen(false);
  };

  const footer = (
    <div className='flex justify-end gap-2'>
      <CancelButton onClick={() => setOpen(false)} disabled={loading} />
      <Button
        onClick={() => handleCreate()}
        text={t(TranslationKey.create).singular.upper}
        loading={loading}
        disabled={!input.validate()}
      />
    </div>
  );

  return (
    <ActionModal
      title={t(TranslationKey.binConstraintCreate).singular.upper}
      open={open}
      setOpen={setOpen}
      footer={footer}
    >
      <BinConstraintInfoPane input={input} setInput={setInput} />
    </ActionModal>
  );
}
